import { render, staticRenderFns } from "./PlayableCard.vue?vue&type=template&id=cb238d70&scoped=true&"
import script from "./PlayableCard.vue?vue&type=script&lang=js&"
export * from "./PlayableCard.vue?vue&type=script&lang=js&"
import style0 from "./PlayableCard.vue?vue&type=style&index=0&id=cb238d70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb238d70",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WordActions: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/results/WordActions/WordActions.vue').default,DefinitionContent: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/results/Definition/DefinitionContent.vue').default})
